import Vue from 'vue';

let appInstance: Vue | null = null;

export function initUserSettings(app: Vue): void {
    appInstance = app;
}

export function getUserSetting(key: string, defaultValue: string | null = null): string | null {
    const serverValue = appInstance?.$root?.$data?.userSettings?.[key];
    if (serverValue !== undefined) return serverValue;

    // Fallback to localStorage (pre-SignalR or first-time migration)
    const localValue = localStorage.getItem(key);
    if (localValue !== null) {
        // Migrate: push to server (also caches back to localStorage via saveUserSetting)
        saveUserSetting(key, localValue);
        return localValue;
    }
    return defaultValue;
}

export function getUserSettingParsed<T>(key: string, defaultValue: T): T {
    const raw = getUserSetting(key);
    if (raw === null) return defaultValue;
    try { return JSON.parse(raw) as T; }
    catch { return defaultValue; }
}

export function saveUserSetting(key: string, value: string): void {
    // Immediate local reactivity
    if (appInstance?.$root?.$data?.userSettings) {
        Vue.set(appInstance.$root.$data.userSettings, key, value);
    }
    // Persist to server via SignalR
    (Vue.prototype as any).$saveUserSetting?.(key, value);
    // Sync cache for next page load
    try { localStorage.setItem(key, value); } catch { /* quota exceeded */ }
}

export function deleteUserSetting(key: string): void {
    if (appInstance?.$root?.$data?.userSettings) {
        Vue.delete(appInstance.$root.$data.userSettings, key);
    }
    (Vue.prototype as any).$deleteUserSetting?.(key);
    localStorage.removeItem(key);
}
